import { useMemo } from "react";
import { useProcurementMethods } from "./common-types";

interface SelectedIdsWithCsv {
	selectedValues: string[];
	selectedValuesCsv: string;
}

export const useProcurementMethodNamesSelected = (
	selectedIds: string[] | number[] | undefined
): SelectedIdsWithCsv & { isLoading: boolean } => {
	const { values, isLoading } = useProcurementMethods();

	// we will compute based upon values
	const { selectedValues, selectedValuesCsv } =
		useMemo((): SelectedIdsWithCsv => {
			if (isLoading || !selectedIds || selectedIds.length === 0) {
				return { selectedValues: [], selectedValuesCsv: "" };
			}

			// Normalize to strings to avoid type issues
			const selectedSet = new Set(selectedIds.map(String));

			const selectedValues = values.flatMap((item) =>
				selectedSet.has(String(item.value)) ? [item.label] : []
			);

			return {
				selectedValues: selectedValues,
				selectedValuesCsv: selectedValues.join(", "),
			};
		}, [values, selectedIds, isLoading]);

	return { isLoading, selectedValues, selectedValuesCsv: selectedValuesCsv };
};
